export const RESUME_LIBRARY_LABEL = 'Resume Library';
export const VIEW_RESUME_LIBRARY_LABEL = 'View Resume Library';

export const getSourceTypeLabel = (sourceType, platform = '') => {
  const normalizedSource = String(sourceType || '').toLowerCase();
  const normalizedPlatform = String(platform || '').toLowerCase();

  if (normalizedSource === 'google' || normalizedSource === 'google_search') return 'Online Sourcing';
  if (normalizedSource === 'linkedin' || normalizedSource === 'linkedin_paid') return 'LinkedIn';
  if (normalizedSource === 'naukri') return 'Naukri';
  if (normalizedSource === 'resume_box') return RESUME_LIBRARY_LABEL;
  if (normalizedSource === 'job_post') {
    if (normalizedPlatform.includes('linkedin')) return 'Job Post - LinkedIn';
    if (normalizedPlatform.includes('naukri')) return 'Job Post - Naukri';
    return 'Job Post';
  }

  return '';
};

export const getResumeStatusLabel = (status) => {
  const normalized = String(status || '').toLowerCase();

  if (normalized === 'parsed' || normalized === 'completed') return 'Analyzed';
  if (normalized === 'processing') return 'Processing';
  if (normalized === 'queue' || normalized === 'queued' || normalized === 'pending') return 'Queued';
  if (normalized === 'failed' || normalized === 'error') return 'Failed';

  return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : 'Queued';
};
